import { Injectable } from '@angular/core';
import { GaApplicationsConfig } from '../models/index';

@Injectable({
    providedIn: 'root',
})
export class GaApplicationsConfigService {

    #config: GaApplicationsConfig = new GaApplicationsConfig();
    #favoritesGroupName = 'favorites';

    get config(): GaApplicationsConfig { return this.#config; }
    get favoritesGroupName(): string { return this.#favoritesGroupName; }

    addConfig(config?: GaApplicationsConfig): void {
        this.#config.productName = config?.productName ?? this.#config.productName;
        this.#config.defaultFavoritesIds = config?.defaultFavoritesIds ?? this.#config.defaultFavoritesIds;
    }
}
